import { render, staticRenderFns } from "./AddSavedLocations.vue?vue&type=template&id=1a667e33"
import script from "./AddSavedLocations.vue?vue&type=script&lang=ts"
export * from "./AddSavedLocations.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports